var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-img",style:({ backgroundImage: 'url(' + 'https://www.fotografi-cameramani.ro/upload/useri_echipa/fotografie/photo/' + _vm.photo + ')' })})}
var staticRenderFns = []

export { render, staticRenderFns }